// extracted by mini-css-extract-plugin
module.exports = {"Modal":"ModalUser_Modal__3BbCh","ModalContent":"ModalUser_ModalContent__2V87M","BtnDecline":"ModalUser_BtnDecline__2oNUY"};